/**
 * Created by Jerker Nord on 2020-10-07.
 */
import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

export class MonkeysGoldSpinController extends SpinController {

    constructor() {
        super();
    }

    protected onAllReelsSpinStarted():void {
        // Tells the api
        EventHandler.dispatchEvent(new GameEvent(SpinEvent.STARTED));
        if(this._mode == GameMode.NORMAL || this._mode == GameMode.FREESPIN) {
            this.addStopDelay(this.getSpinTime());
        }
        this.onSpinTimerDone();
    }
}